import { Component, OnInit } from '@angular/core';
import { Code } from './../../code/table';

@Component({
  templateUrl: './table.component.html'
})
export class TableComponent implements OnInit {

    code = Code;
    parameters: any[];
    headers: any[];
    constructor() { }

    ngOnInit() {
        this.parameters = [
            {name: "operate",type: "boolean",default: "false",des: "当该属性被指定时，列表多了自定义操作列。"},
            {name: "pageData",type: "Object",default: "null",des: "定义每页多少条数据，一共有多少条数据。"},
            {name: "tableData",type: "Object",default: "null",des: "定义列表数据。"}
        ];

        this.headers = [
            {name : "名字"},
            {name : "类型"},
            {name : "默认"},
            {name : "描述"}
        ];
    }

    curObj;
    num;
    appPage = {
        size: 10,
        total: 100
    };

    proTableData = {
        operate: false,
        th: [
          {
            'title': '名称'
          },
          {
            'title': '别名'
          },
          {
            'title': '创建人'
          },
          {
            'title': '更新时间'
          }
        ],
        td: [
          {
            a: {
              title: "name",
              url: "appUrl",
              params: "appParams"
            }
          },
          {
            key: "display_name"
          },
          {
            key: "created_by"
          },
          {
            key: "update_at"
          }
        ],
        list: [{
            appUrl: "/project/detail",
            appParams: { id: '11111111' },
            name: "digitalOne",
            created_by: "张三",
            display_name: "digitalone",
            update_at: "2018-04-03 15:35:30",
            showOperateList: [{
              a: {
                'name': '删除',
                'fn': 'delShow'
              }
            }]
        }],
    };


    proTableCom = {
        operate: true,
        th: [
          {
            'title': '名称'
          },
          {
            'title': '别名'
          },
          {
            'title': '创建人'
          },
          {
            'title': '更新时间'
          }
        ],
        td: [
          {
            a: {
              title: "name",
              url: "appUrl",
              params: "appParams"
            }
          },
          {
            key: "display_name"
          },
          {
            key: "created_by"
          },
          {
            key: "update_at"
          }
        ],
        list: [{
          appUrl: "/project/detail",
          appParams: { id: '11111111' },
          name: "digitalOne",
          created_by: "张三",
          display_name: "digitalone",
          update_at: "2018-04-03 15:35:30",
          showOperateList: [
            {
              a: {
                'name': '删除',
                'fn': 'delShow'
              }
            }]
        }],
    };

    updatePageList(obj) {
        this.num = obj.num;
    }

    getOptInfo(e) {
        this.curObj = e.optInfo.targetObj;
        if (e.optInfo) {
          this[e.optInfo.optName]();
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/view/table/table.component.ts